// extracted by mini-css-extract-plugin
export default {"headline_div":"Headline_headline_div__09h-o","headline_text":"Headline_headline_text__fzhol","headline_border_bottom":"Headline_headline_border_bottom__g20WJ"};